<template>
  <div class="layout-wrapper">
    <div class="content">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <tab-bar :config="config" v-model="active" @change="onChange" /> </div>
</template>
<script>
import TabBar from '../TabBar'
import config from './config.js'
export default {
  name: 'layout',
  data() {
    return {
      active: 0,
      config: config.tabBar
    }
  },
  created() {
    this.initActive()
  },
  watch: {
    $route() {
      this.initActive()
    }
  },
  components: {TabBar},
  methods: {
    initActive() {
      this.config.findIndex((item, index) => {
        if (item.pagePath === this.$route.path) {
          this.active = index
        }
      })
    },
    onChange(_, item) {
      if (item?.type === "button") {
        this.$router.push({path:item.pagePath})
      } else {
        this.$router.replace({path:item.pagePath})
      }
    }
  }
}

</script>
<style scoped lang="scss">
.layout-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}
.content {
  min-height: 0;
  flex: 1;
  width: 100%;
  overflow-x:hidden;
  overflow-y:auto;
}

</style>
